import React, { Fragment } from 'react';
import { CaretRightIcon } from '@panwds/icons';

function Breadcrumbs(_a) {
    var breadcrumbs = _a.breadcrumbs;
    if (!breadcrumbs.length)
        return null;
    return (React.createElement("div", { className: "tw-font-lato tw-flex tw-items-center tw-space-x-1 tw-text-xs tw-mb-4" }, breadcrumbs.map(function (breadcrumb, index) { return (React.createElement(Fragment, { key: index },
        breadcrumb,
        index < breadcrumbs.length - 1 && (React.createElement(CaretRightIcon, { size: "sm", className: "tw-mt-1" })))); })));
}

export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.esm.js.map
